import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/buscar/ses-email';
const RESOURCE_EVENTS = '/v2/buscar/ses-event';
const RESOURCE_SUPRESSED = '/v2/buscar/ses-email-suppression';
const RESOURCE_RECEIVED = '/v2/buscar/ses-event-received';

export const ioGetEmailList = ({ body }) => apiClient.post(
  `${RESOURCE}`,
  body,
  { operacionId: 'io.email.list' }
);
export const ioGetEmailTrace = ({ mailid }) => apiClient.get(
  `/v2/herramientas/email?mailid=${mailid}`,
  { operacionId: 'io.email.list' }
);

export const ioGetEmailSupressedList = ({ body }) => apiClient.post(
  `${RESOURCE_SUPRESSED}`,
  body,
  { operacionId: 'io.email.suppressed.list' }
);

export const ioDeleteEmailSupressed = ({ id }) => apiClient.delete(
  `/v2/herramientas/email/${id}/suppressed`,
  { operacionId: 'io.email.suppressed.list' }
);

export const ioGetEmailEventsList = ({ params }) => {
  const parameters = apiClient.queryParams(params);
  return apiClient.get(
    `${RESOURCE_EVENTS}?${parameters}`,
    { operacionId: 'io.email.events.list' }
  );
};

export const ioGetReceivedEmailList = ({ body }) => apiClient.post(
  `${RESOURCE_RECEIVED}`,
  body,
  { operacionId: 'io.email.received.list' }
);
